module.exports = __webpack_public_path__ + "static/media/fenqihudadongshan_mobile.66ca20ec.webp";